import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Field, FieldType, OptionSvcCmp} from '../../../../../common/components/form/models';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {SubSink} from '@Common/core/utils/subsink';
import {FilterFieldCustomEnabled} from '../../../../../common/services/responses/filter-field-custom-enabled.model';
import {FilterFieldOperator} from '../../../../../common/services/responses/filter-field-operator.enum';

import {Pagination} from '@Common/widgets/general/pagination';
import {Entite} from '@Services/entite/entite.model';
import {EntiteService} from '@Services/entite/entite.service';
import { constantes } from 'app/demat/common/constantes';

/**
 * Affichage des valeurs possible à filtrer pour le champ filtré
 */
@Component({
  selector: 'app-filter-type-value',
  templateUrl: './filter-type-value.component.html',
  styleUrls: ['./filter-type-value.component.scss']
})
export class FilterTypeValueComponent implements OnInit, OnDestroy {
  @Input() field: Field;
  @Output() valueChanged: EventEmitter<FilterFieldCustomEnabled> = new EventEmitter<FilterFieldCustomEnabled>();
  formControl: UntypedFormGroup;
  value: any;
  fieldType = FieldType;
  listSvcCmp: Entite[];
  subSink = new SubSink();
  extraParams: Map<string, string> = new Map<string, string>();
  constantes = constantes;
  constructor(private formBuilder: UntypedFormBuilder,
              private entiteSvc: EntiteService) { }
  ngOnInit(): void {
    this._initForm();
    this._fetchSvcCmp();
  }
  private _fetchSvcCmp() {
    if (this.field.options_obj.controlType === FieldType.TypeSvcCmp) {
      const options = this.field.options_obj as OptionSvcCmp;
      this.extraParams.set('by_type', options.entite.toString());
      this.extraParams.set('application', constantes.application.toString());
      this.subSink.sink = this.entiteSvc.listAllItems(this.extraParams).subscribe(
        (_data) => {
          this.listSvcCmp = _data.list;
          this.entiteSvc.sortBy(this.listSvcCmp);
        });
    }
  }
  private _initForm() {
    this.formControl = this.formBuilder.group({value: []});
    this.subSink.sink = this.formControl.controls['value'].valueChanges.subscribe(_value => {
      const _fieldEnabled = <FilterFieldCustomEnabled> {
        field: this.field.id,
        label: this.field.options_obj.label,
        value: _value,
        type: this.field.options_obj.controlType,
        operator: FilterFieldOperator.EXACT
      };
      this.valueChanged.emit(_fieldEnabled);
    });
  }
  onValidate() {

  }
  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }
}
